module.exports = __webpack_public_path__ + "static/media/styledDatepicker-Chevrom-Left.465bfaee.svg";